import { Capacitor } from '@capacitor/core';

/**
 * Get the base URL for API requests.
 * - Native apps: Use absolute URL from environment variable
 * - Web: Use relative URL (proxied by Vite in development)
 */
export function getApiBaseUrl(): string {
  if (Capacitor.isNativePlatform()) {
    // Native app - must use absolute URL to backend
    return import.meta.env.VITE_API_URL || 'https://api.cmdbridge.com';
  }
  // Web - use relative URL (proxied by Vite in dev, same origin in prod)
  return '';
}

/**
 * Check if running as a native mobile app
 */
export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}

/**
 * Get the platform name (ios, android, or web)
 */
export function getPlatform(): string {
  return Capacitor.getPlatform();
}
